import React from 'react'
import styled from 'styled-components'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Colors from 'styles/colors'

const ReferralBanner = () => (
  <StyledReferralBanner aria-label="友達紹介特典">
    <StyledBenefitImage
      src={imagePath('service/referral/referral-banner-point.svg')}
      alt="会員登録後、電話番号認証の完了ですぐに1,000ポイントプレゼント！"
    />
  </StyledReferralBanner>
)

export default ReferralBanner

const StyledReferralBanner = styled.section`
  box-sizing: border-box;
  width: 100%;
  --triangle-height: 32px;
  margin: 0 auto;
  padding-top: 32px;
  padding-bottom: 56px;
  background: ${Colors.mono.white};
  color: ${Colors.mono.gray100};
  text-align: center;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - var(--triangle-height)),
    50% 100%,
    0 calc(100% - var(--triangle-height))
  );

  & + .lp-page__padding {
    padding-top: 40px;
  }

  @media screen and (min-width: 768px) {
    width: calc(100% - 32px);
    --triangle-height: 44px;
    padding-right: 32px;
    padding-left: 32px;
  }

  @media screen and (min-width: 992px) {
    width: 100%;
    max-width: 810px;
  }
`

const StyledBenefitImage = styled.img`
  display: block;
  width: 343px;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
`
